import React from "react";
import {
  Card,
  DataTable,
  Button,
  Checkbox,
  Text,
  Thumbnail,
} from "@shopify/polaris";
import { PAGE_SIZE } from "../../constants/common-constants";

const ProductTable = ({
  products,
  setCurrentPage,
  currentPage = "",
  selectedProducts = null,
  setSelectedProducts,
  allowCheck = true,
  handleList = null,
}) => {
  const rows = products.map((product) => [
    allowCheck ? (
      <Checkbox
        checked={selectedProducts.some(
          (item) => item.product._id === product._id
        )}
        onChange={() =>
          setSelectedProducts({
            product,
            variantId: product.variants[0].id,
          })
        }
      />
    ) : (
      <Thumbnail
        source={product.images[0]?.src}
        alt="Cover Photo"
        size="small"
      />
    ),
    <div
      style={{
        maxWidth: "200px",
        whiteSpace: "normal",
        wordBreak: "break-word",
      }}
    >
      {product.title}
    </div>,
    product.vendor,
    product.totalInventory,
    product.updatedAt
      ? new Date(product.updatedAt).toLocaleDateString()
      : "N/A",
    !allowCheck ? (
      <Button
        onClick={() => {
          handleList(product);
        }}
        variant="primary"
      >
        List as bundle
      </Button>
    ) : (
      ""
    ),
  ]);

  return (
    <Card>
      <DataTable
        hideScrollIndicator
        columnContentTypes={["text", "text", "text", "text", "text"]}
        headings={[
          allowCheck ? (
            <Text variant="headingSm">Check</Text>
          ) : (
            <Text variant="headingSm">Image</Text>
          ),

          <Text variant="headingSm">Product Name</Text>,
          <Text variant="headingSm">Vendor</Text>,
          <Text variant="headingSm">Inventory</Text>,
          <Text variant="headingSm">Last Updated</Text>,
          !allowCheck ? <Text variant="headingSm">Actions</Text> : "",
        ]}
        rows={rows}
        pagination={{
          hasNext: products.length >= PAGE_SIZE,
          onNext: () => {
            setCurrentPage(currentPage + 1);
          },
          onPrevious: () => {
            if (currentPage > 1) {
              setCurrentPage(currentPage - 1);
            }
          },
          hasPrevious: currentPage > 1,
        }}
      />
    </Card>
  );
};

export default ProductTable;
